
import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, Injector, NgModule } from "@angular/core";
import { AppService } from "../../shared/services/app.service";
import { KxAIModelComponent } from "./components/kx-ai-model/kx-ai-model.component";
import { AIService } from "./services/ai.service";
import { KxAIFillingComponent } from "./components/kx-ai-filling/kx-ai-filling.component";
import { KxAISummaryComponent } from "./components/kx-ai-summary/kx-ai-summary.component";
import { KxAISpeechComponent } from "./components/kx-ai-speech/kx-ai-speech.component";
import { TranslateModule } from "../../pipes/translate.module";
import { AI_DECORATOR_DEF } from "./docrators/aiDeocratorDef";
import { KxAIRecieptEditorComponent } from "./components/kx-ai-reciept-editor/kx-ai-reciept-editor.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { KxAiOutputComponent } from "./components/kx-ai-output/kx-ai-output.component";
import { KxAIDataAnalysisComponent } from "./components/kx-ai-data-analysis/kx-ai-data-analysis.component";
import { KxAiDataAnalysisOutputComponent } from "./components/kx-ai-data-analysis-output/kx-ai-data-analysis-output.component";
import { ReportBuilderService } from "./components/kx-ai-report-viewer/report-builder.service";
import { KxAiReportViewerComponent } from "./components/kx-ai-report-viewer/kx-ai-report-viewer.component";
import { DynamicHeaderComponent } from "./components/kx-ai-report-viewer/dynamic-header/dynamic-header.component";
import { DynamicCellComponent } from "./components/kx-ai-report-viewer/dynamic-cell/dynamic-cell.component";
import { DynamicSectionComponent } from "./components/kx-ai-report-viewer/dynamic-section/dynamic-section.component";
import { KxAIEditingComponent } from "./components/kx-ai-editing/kx-ai-editing.component";
import { TranscriptionService } from "./components/kx-ai-speech/transcription.service";
import { PatientSummaryComponent } from "./components/kx-ai-patient-summary/kx-ai-patient-summary";
import { BillingSummaryComponent } from "./components/kx-ai-billing-summary/kx-ai-billing-summary";

@NgModule({
    declarations: [
        KxAISummaryComponent,
        KxAIFillingComponent,
        KxAIModelComponent,
        KxAISpeechComponent,
        KxAIRecieptEditorComponent,
        KxAiOutputComponent,
        KxAIDataAnalysisComponent,
        KxAiDataAnalysisOutputComponent,
        KxAiReportViewerComponent,
        DynamicHeaderComponent,
        DynamicCellComponent,
        DynamicSectionComponent,
        KxAIEditingComponent,
        PatientSummaryComponent,
        BillingSummaryComponent
    ],
    providers:[
      ReportBuilderService,
      TranscriptionService
    ],
    imports:[
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule
    ],
    exports:[
        KxAISummaryComponent,
        KxAIFillingComponent,
        KxAIModelComponent,
        KxAISpeechComponent,
        KxAIRecieptEditorComponent,
        KxAiOutputComponent,
        KxAIDataAnalysisComponent,
        KxAiDataAnalysisOutputComponent,
        KxAiReportViewerComponent,
        DynamicHeaderComponent,
        DynamicCellComponent,
        DynamicSectionComponent,
        KxAIEditingComponent,
        PatientSummaryComponent,
        BillingSummaryComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AiMlModule {
    public entryComponents: any = [
        KxAISummaryComponent,
        KxAIFillingComponent,
        KxAIModelComponent,
        KxAISpeechComponent,
        KxAIRecieptEditorComponent,
        KxAiOutputComponent,
        KxAIDataAnalysisComponent,
        KxAiDataAnalysisOutputComponent,
        KxAiReportViewerComponent,
        DynamicHeaderComponent,
        DynamicCellComponent,
        DynamicSectionComponent,
        KxAIEditingComponent,
        PatientSummaryComponent,
        BillingSummaryComponent
    ]
    public appService: AppService;
    public aiService: AIService;
  constructor(public injector: Injector) {
    this.appService = injector.get(AppService);
    this.aiService = injector.get(AIService);
    this.appService._factories["modules"]["AiMlModule"] = this.entryComponents;
    this.aiService.AI_DECORATOR_DEF = AI_DECORATOR_DEF;  
    if (this.entryComponents && this.entryComponents.length) {
      this.appService.buildFactory(this.entryComponents);
    }
  }
}
